import styled from "styled-components"
import { themeGet } from "@styled-system/theme-get"

const Wrapper = styled.div`
  padding: 73px 0 100px;
  @media (max-width: 568px) {
    padding: 32px 0 64px;
  }

  .container {
    display: flex;
    gap: 14px;
    justify-content: space-between;
    @media (max-width: 900px) {
      flex-direction: column;
      gap: 14px;
    }

    .content {
      display: flex;
      flex-direction: column;
      margin: auto;
      background-color: #f9f9f9;
      justify-content: center;
      padding: 36px 36px 10px;
      height: 100%;
      @media only screen and (max-width: 568px) {
        padding: 24px;
      }

      hr {
        background: ${themeGet("colors.mainBlue")};
        width: 80px;
        height: 4px;
        border: none;
        margin: 0px 0px 10px 0px;
      }

      .title {
        color: ${themeGet("colors.mainBlue")};
        font-weight: 600;
        font-size: 20px;
        line-height: 26px;
        margin-bottom: 14px;
      }

      .text {
        font-weight: 400;
        font-size: 16px;
        color: #000000;
        line-height: 26px;
        margin-bottom: 26px;
      }
    }

    .left-col {
      display: flex;
      flex-direction: column;
      gap: 14px;
      width: 50%;
      @media (max-width: 900px) {
        width: 100%;
      }
    }

    .right-col {
      width: 50%;
      @media (max-width: 900px) {
        width: 100%;
      }
    }
  }
`

export default Wrapper
